import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes.js';
import { setupPermissionGuard } from './permissionGuard.js';

const router = createRouter({
    history: createWebHistory(),
    routes
});

setupPermissionGuard(router);

export default router;
